var _defs, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.269,
    height: 35.164,
    viewBox: "0 0 30.269 35.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dadee0;}.b{fill:#1bb7ea;}.c{fill:#f2f2f2;}.d{fill:#1f4254;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M109.847,58.991a2.679,2.679,0,0,0-2.671-2.671H87.146a2.679,2.679,0,0,0-2.671,2.671V83.917a2.679,2.679,0,0,0,2.671,2.671h15.133l7.567-7.122Z",
    transform: "translate(-79.579 -51.424)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M33.051,7.567A2.679,2.679,0,0,1,35.722,4.9H53.527V2.671A2.679,2.679,0,0,0,50.857,0H30.826a2.679,2.679,0,0,0-2.671,2.671V27.6a2.679,2.679,0,0,0,2.671,2.671h2.226Z",
    transform: "translate(-28.155)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M291.936,322.56h4.9l-7.567,7.122v-4.451A2.678,2.678,0,0,1,291.936,322.56Z",
    transform: "translate(-266.565 -294.518)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.905 10.905)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M154.263,177.975h12.018a.668.668,0,0,0,0-1.335H154.263a.668.668,0,1,0,0,1.335",
    transform: "translate(-153.595 -172.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M154.263,126.775h12.018a.668.668,0,0,0,0-1.335H154.263a.668.668,0,1,0,0,1.335",
    transform: "translate(-153.595 -125.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M154.263,229.175h12.018a.668.668,0,0,0,0-1.335H154.263a.668.668,0,1,0,0,1.335",
    transform: "translate(-153.595 -218.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M154.263,280.375h6.677a.668.668,0,0,0,0-1.335h-6.677a.668.668,0,0,0,0,1.335",
    transform: "translate(-153.595 -265.687)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/category_icon.b2115aa8dbbf4f75a9fed7a1a36eec7f.svg";
export { ForwardRef as ReactComponent };